/**
 * MaskedTextbox base modules
 */
export * from './mask-base';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-inputs/src/maskedtextbox/base/index.js
// module id = 481
// module chunks = 0